import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SportService, UserService } from '@app/core';
import { CommonService } from '@app/core/services/common.service';
import { environment } from '@environments/environment';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-top-users',
  templateUrl: './top-users.component.html',
  styleUrls: ['./top-users.component.scss'],
})
export class TopUsersComponent implements OnInit {
  sport: any;
  topusers: any[] = [];
  assetUrl = environment.assetUrl;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  /**
   *
   * @param {CommonService}_common
   * @param {SportService}_sportService
   * @param {UserService}_userService
   */
  constructor(
    public _common: CommonService,
    public _sportService: SportService,
    private _userService: UserService,
    private _activated: ActivatedRoute
  ) { }

  ngOnInit() {
    this._activated.data.pipe(takeUntil(this.destroyed$)).subscribe(async (data) => {
      this.sport = data['sport'] || this._sportService.defaultSport;
      let param = new HttpParams()
        .set('sport', this.sport.toLocaleLowerCase())
        .set('limit', 4);
      let res = await this._userService.topUsers(param);
      this.topusers = res.data;
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
